import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryPurchaseOrderReceivedPO = createAsyncThunk(
  "inventory/fetchInventoryPurchaseOrderReceivedPO",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await ProcurementAxios.get(
        `/purchase-order/list/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Purchase Order Received PO List error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Puchase Order  Received PO List");
    }
  }
);

export const fetchinventoryPOById = createAsyncThunk(
  "procurement/fetchinventoryPOById",
  async (po_id: string, { rejectWithValue }) => {
    try {
      const response = await ProcurementAxios.get(
        `/purchase-order/${po_id}/get/`
      );
      // const response = await ProcurementAxios.get(`/approved-pr/831a7a4e-bfe4-43dd-b7ac-141d9daa7b2b/`);

      return response.data;
    } catch (error: any) {
      console.error("Error fetching PR by ID:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch PR details"
      );
    }
  }
);

export const getPOItemsViewDetailsByItemID = createAsyncThunk(
  "fetch/getPOItemsViewDetailsByItemID",
  async (
    { item_id, po_item_id }: { item_id: string; po_item_id: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await InventoryAxios.get(
        `/api/inventory-purchase-order/view-items-details/${item_id}/${po_item_id}/`
      );
      // const res = await InventoryAxios.get(`/api/inventory-purchase-order/view-items-details/fb7e2624-ee6c-44dc-b68d-3171630eddc6/98d8597e-8b4a-4f84-bf12-f3baa6cd12b6/`);

      return res;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Faield to fetch getPOItemsViewDetailsByItemID"
      );
    }
  }
);

export const exportCSVInventoryPurchaseOrder = createAsyncThunk(
  "suppliers/exportCSVInventoryPurchaseOrder",
  async (
    {
      filters,
    }: {
      filters?: ColumnFiltersState;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };

      const params: Record<string, any> = {
        export: "csv",
      };

      // Only apply column filters (not global search)
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;

          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object"
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (from_date) params["from_date"] = from_date;
            if (to_date) params["to_date"] = to_date;
          } else {
            params[id] = value;
          }
        });
      }

      const response = await ProcurementAxios.get(
        "/purchase-order/list/?export=csv",
        {
          headers,
          params,
          responseType: "blob",
        }
      );

      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Purchase Order.csv",
      };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

// export const fetchInventoryPurchaseOrderGRN = createAsyncThunk(
//   "inventory/fetchInventoryPurchaseOrderGRN",
//   async ({
//     page,
//     pageSize,
//     sort,
//     order,
//     search,
//     filters,
//   }: {
//     page: number;
//     pageSize: number;
//     search?: string;
//     sort?: string;
//     order?: "asc" | "desc" | "";
//     filters?: any;
//   }) => {
//     try {
//       const params = new URLSearchParams();
//       params.append("page", page.toString());
//       params.append("page_size", pageSize.toString());
//       if (search) params.append("search", search);
//       if (sort) {
//         const orderingValue = order === "desc" ? `-${sort}` : sort;
//         params.append("ordering", orderingValue);
//       }

//       if (filters && filters.length > 0) {
//         console.log(JSON.stringify(filters));
//         filters.forEach(
//           ({
//             filterField,
//             filterValue,
//           }: {
//             filterField: string;
//             filterValue: any;
//           }) => {
//             if (
//               filterField &&
//               filterValue !== undefined &&
//               filterValue !== null
//             ) {
//               if (typeof filterValue === "object" && filterValue !== null) {
//                 // Handle cases like { from_date: ..., to_date: ... }
//                 Object.entries(filterValue).forEach(([key, value]) => {
//                   if (value !== undefined && value !== null && value !== "") {
//                     params.append(key, String(value));
//                   }
//                 });
//               } else {
//                 params.append(filterField, filterValue);
//               }
//             }
//           }
//         );
//       }

//       // const response: any = await WarehouseAxios.get(`/project-warehouse/list/${params.toString()}`);
//       const response: any = await axios.get("https://216kcd9t-8002.inc1.devtunnels.ms/project-warehouse/list/?page=1&page_size=10")

//       return {
//         data: response?.data?.data || [],
//         rowCount: response?.data?.count || 0,
//       };
//     } catch (error: any) {
//       console.error(
//         "fetch Purchase Order GRN List error:",
//         error.response?.data || error.message
//       );
//       throw new Error("Failed to fetch Puchase Order GRN List");
//     }
//   }
// );
